/* global Swiper, attachEvent */
// *******************************************************************************
// 1.0 - Image Slider
// *******************************************************************************

const imageSliderElements = document.querySelectorAll('[data-slider="image-slider"]');

const imageSliderOptions = {
  slidesPerView: 'auto',
  speed: 600,
  watchOverflow: true,
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.arrow-right',
    prevEl: '.arrow-left',
  },
};

imageSliderElements.forEach((el) => {
  const imageSliderParent = el.closest('.image-slider');
  const paginationElement = imageSliderParent.querySelector('.swiper-pagination');
  const arrowRight = imageSliderParent.querySelector('.arrow-right');
  const arrowLeft = imageSliderParent.querySelector('.arrow-left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;
  imageSliderOptions.pagination.el = paginationElement;
  // eslint-disable-next-line no-new
  const ImageSlider = new Swiper(el, imageSliderOptions);

  attachEvent('.card__inner', 'click', () => {
    ImageSlider.update();
  });
});
